export default {
  autoUpdate: 'Aktualizuj automatycznie (co {0})',
  updateInterval: 'Interwał aktualizacji',
  lastUpdate: 'Ostatnia aktualizacja',
  nextUpdate: 'Następna aktualizacja za {0}',
};
